module.exports = __webpack_public_path__ + "img/question13c4.565c0121.png";